export const mainFetchUrl = "https://api.themoviedb.org/3";
export const posterUrl = "https://image.tmdb.org/t/p/w220_and_h330_face";
export const castPhotoUrl = "https://image.tmdb.org/t/p/w138_and_h175_face";
export const backdropUrl = "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces";
export const apiKey = "e7fee3c7b4caf8e9686ec3e9a37ba4d9";
